import React from "react";
import R from "ramda";
import styled from "styled-components";
import { connect } from "react-redux"
import { compose, withPropsOnChange, withState, withHandlers, getContext, } from "recompose";
import PropTypes from "prop-types";

import * as v from "src/components/style/vars";
import * as m from "src/components/style/mixins";

import { Button, Burger, } from "src/components/common";

// --------------------------------------------------

const Wrapper = styled.div`
	position: fixed;
	left: ${v.dim.panel.width.other};
	${m.xs`left: 0;`}
	right: 0;
	top: 0;
	height: ${v.dim.nav.height};
	background-color: black;
	background-color: #444;
	color: white;
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 0 2em;
	${m.xs`padding: 0 1em;`}
	z-index: 1;
	${m.shadow(2)}
`;

const Left = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`;

const Right = styled.div`
	margin-left: auto;
`;

const TitleWrapper = styled.div`
	margin-right: 1em;
`;

const Title = styled.div`
	font-size: 1.5em;
	${m.xs`font-size: 1.2em;`}
	font-weight: bold;
	text-transform: uppercase;
`;

const burgerPadding = 13;

const BurgerWrapper = styled.div`
	${m.bp.sm.min`display: none;`}
	margin-left: -${burgerPadding}px;
`;

// --------------------------------------------------

const enhance = compose(
	connect(
		R.pick(['panelOpen']),
		{
			openPanel: () => ({ type: 'OPEN_PANEL' }),
			closePanel: () => ({ type: 'CLOSE_PANEL' }),
			togglePanel: () => ({ type: 'TOGGLE_PANEL' }),
		}
	),
	withState("saving", "setSaving", false),
	withHandlers({
		onClickSave: ({ setSaving, save, }) => () => {
			setSaving(true);
			save()
			.then(
				r => {
					setSaving(false);
					window.alert("Changes saved successfully.");
				},
				r => {
					setSaving(false);
					window.alert("Something went wrong saving changes.");
				},
			);
		},
	})
);

const Comp = ({ children, title, saving, onClickSave, save, togglePanel, panelOpen, }) => (
	<Wrapper>
		<Left>
			<BurgerWrapper onClick = { togglePanel }>
				<Burger open = { panelOpen } padding = { burgerPadding }/>
			</BurgerWrapper>
			<TitleWrapper>
				<Title>{ title }</Title>
			</TitleWrapper>
			{ children }
		</Left>
		<Right>
			{
				save
				? (
					<Button
						onClick = { saving ? R.identity : onClickSave }
						text = { saving ? "Saving..." : "Save changes" }
						color = "#1EA896"
					/>
				)
				: null
			}			
		</Right>
	</Wrapper>
);

export default enhance(Comp);


// WEBPACK FOOTER //
// ./src/components/Editor/Topbar.js